import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch, faStore } from "@fortawesome/free-solid-svg-icons";

export default function EduXpressHome() {
  const [pinCode, setPinCode] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [dealers, setDealers] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");

  const categories = [
    { name: "School Bags", img: "🎒" },
    { name: "Uniforms", img: "👔" },
    { name: "Textbooks", img: "📚" },
    { name: "Stationery", img: "✏️" },
    { name: "Shoes", img: "👟" },
    { name: "More", img: "➕" },
  ];

  const handleGetSeller = () => {
    if (pinCode.trim() || neighbourhood.trim()) {
      setDealers([
        "ABC School Supplies",
        "EduMart Stationers",
        "Knowledge Hub Traders",
      ]);
    } else {
      alert("Please enter either PIN Code or Neighbourhood.");
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-blue-600 p-4 text-white flex items-center justify-between shadow-md">
        <h1 className="text-2xl font-bold">ThinkXpress</h1>
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon icon={faMapMarkerAlt} />
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="px-2 py-1 rounded text-black w-28"
          />
        </div>
      </header>

      {/* Search Bar */}
      <div className="p-4 bg-black shadow-sm">
        <div className="flex items-center bg-gray-100 p-2 rounded-lg">
          <FontAwesomeIcon icon={faSearch} className="text-gray-500" />
          <input
            type="text"
            value={neighbourhood}
            onChange={(e) => setNeighbourhood(e.target.value)}
            placeholder="Search neighbourhood or product"
            className="ml-2 bg-transparent outline-none flex-1"
          />
        </div>
      </div>

      {/* Categories */}
      <div className="p-4 grid grid-cols-3 gap-4">
        {categories.map((cat) => (
          <div
            key={cat.name}
            className="flex flex-col text-white border border-blue-400 items-center bg-balck rounded-xl shadow p-4 hover:scale-105 transition"
          >
            <div className="text-4xl mb-2">{cat.img}</div>
            <span className="text-sm font-medium">{cat.name}</span>
          </div>
        ))}
      </div>

      {/* Dealers Section */}
      <div className="p-4">
        <button
          onClick={handleGetSeller}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
        >
          Find Nearby Sellers
        </button>

        {dealers.length > 0 && (
          <div className="mt-4 bg-white rounded-xl shadow p-4">
            <h2 className="text-lg font-semibold mb-2 flex items-center">
              <FontAwesomeIcon icon={faStore} className="mr-2 text-blue-600" /> Sellers Near You
            </h2>
            <select
              value={selectedDealer}
              onChange={(e) => setSelectedDealer(e.target.value)}
              className="w-full border p-2 rounded"
            >
              <option value="">-- Choose Dealer --</option>
              {dealers.map((dealer) => (
                <option key={dealer} value={dealer}>
                  {dealer}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="mt-auto bg-gray-800 text-white text-center p-4 text-sm">
        © 2025 ThinkXpress by Think5Whys
      </footer>
    </div>
  );
}